import classNames from 'classnames';

import type { FC, PropsWithChildren } from 'react';
import React from 'react';

import styles from './styles.module.scss';

interface StickerProps {
  className?: string,
}

const Sticker: FC<PropsWithChildren<StickerProps>> = ({ className, children }) => {
  const cn = classNames(styles.sticker, className);
  return (
    <span className={cn}>
      {children}
    </span>
  );
};

export default Sticker;
